import { Widget, WIDGET_LIVESCORE, TimeoutEvent, ChannelSwitchEvent } from "@gaming/srvg-classes-core";


export class LivescoreWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#livescoreWidget';
        super( options );
        var that = this;

        this.name = 'widgetlivescore';
        this.widgetName = options.widgetName || WIDGET_LIVESCORE;
        this.widgetName = this.product + this.widgetName;


        this.widget = null;

        if (options.selectedChannel){
            this.widgetOptions = {
                selectedChannel: options.selectedChannel
            };
        }else{
            this.widgetOptions = {
                selectedChannel: srvg.videooptions.defaultchannel || 0,
            };
        }

        if (! options.approvalCodeLabel){
            this.widgetOptions.approvalCodeLabel = __('Avv.');
        }

        if (typeof options.showApprovalCode !== "undefined"){
            this.widgetOptions.showApprovalCode = options.showApprovalCode;
        }else if(srvg && srvg.config && srvg.config.modeItaly && srvg.config.modeItaly === true){
            this.widgetOptions.showApprovalCode = true;
        }


        this.widgetOptions['height'] = this.getContainerHeightWithUnit();
        this.widgetOptions['playChannelCallback'] = function (data) {
            that.widgetOptions.selectedChannel = data;
            srvg.eventExchange.triggerEvent(that.name, new ChannelSwitchEvent(data));
        };

        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addLivescoreWidget();
        super.handleDomInstantiated();
    }

    /**
     * add livescore widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addLivescoreWidget(selector?) {
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    setOptions( options: any, fromConstructor?:boolean ) {
        if( fromConstructor ) {
            // if this is called from the constructor, don't call setters
            super.setOptions( options, fromConstructor );
            return;
        }

        if( ! this.widget || this.widget.status != 'INITIALIZED' ) {
            var that = this;
            window.setTimeout( function() {
                    that.setOptions( options )
                },
                500 );
            return;
        }

        super.setOptions( options );

        this.mergeWidgetOptions( options );

        if( this.widget && this.widget.status === 'INITIALIZED' ) {
            var setOptionsSucceeded = false;
            if( this.widget.api && this.widget.api.setOptions ) {
                setOptionsSucceeded = this.widget.api.setOptions( this.widgetOptions );
            }
            if( ! setOptionsSucceeded ) {
                this.recreateWidget( this.widgetName, this.selector, this.widgetOptions );
            }
        }
        else {
            console.error( 'Cannot set options on widget', this.widget.status, this.widget );
        }
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addLivescoreWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(selector, eventdata){
        this.addLivescoreWidget(selector);
    }

    /**
     * calls widget api setChannel to switch channel
     * it is not necessary to switch the channel if livescore widget is connected with widget via widget group
     * @param number channel equivalent to videochannel
     */
    setChannel(channel?: number){
        if(this.widget.api && typeof this.widget.api.setChannel === "function"){
            this.widget.api.setChannel(channel);
        }
    }

    // destroy the widget for inactivity
    handleTimeoutEvent(event: TimeoutEvent, provider){
        this.destroyWidget(this.widget, this.name);
    }

    handleChannelSwitchEvent(event: ChannelSwitchEvent, provider){
        this.widgetOptions.selectedChannel = event.newChannel;
        this.setChannel(event.newChannel);
    }
}
